<!-- Download Template Button -->
<button 
  title="Télécharger le modèle de fichier" 
  type="button" 
  class="btn btn-md custom_btn_primary" 
  (click)="downloadExcelTemplate()"
  [disabled]="busyGet">
  <i class="fa fa-download"></i>&nbsp; 
  <span *ngIf="!busyGet">Modèle fichier</span>
  <span *ngIf="busyGet">Téléchargement...</span>
</button>
&nbsp;

<!-- Import File Button -->
<button 
  title="Importer un fichier Excel de bénéficiaires" 
  class="btn btn-md custom_btn_primary" 
  (click)="triggerFileInput()"
  [disabled]="isProcessingFile">
  <i class="fa fa-file-import"></i>&nbsp; 
  <span *ngIf="!isProcessingFile">Importer fichier</span>
  <span *ngIf="isProcessingFile">Traitement...</span>
</button>
&nbsp;

<!-- Add Beneficiary Button -->
<button 
  title="Ajouter nouveau bénéficiaire" 
  type="button" 
  class="btn btn-md custom_btn_primary" 
  (click)="openAddItemModal()">
  <i class="fa fa-plus"></i>&nbsp; Ajouter
</button>

<!-- Hidden File Input -->
<input 
  #fileInput 
  id="file" 
  type="file" 
  accept=".xlsx,.xls" 
  style="visibility: hidden; width: 1px; height: 1px; position: absolute;" />

<!-- Processing Indicator -->
<div *ngIf="isProcessingFile" class="alert alert-info mt-2">
  <i class="fa fa-spinner fa-spin"></i> Traitement du fichier en cours...
</div>